import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FabIntegrationSnackbar from './FabIntegrationSnackbar';
import ClientProvider from './client';
export default createDemo(import.meta.url, FabIntegrationSnackbar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/snackbars/demos/fab-integration/FabIntegrationSnackbar.tsx",
    "fileName": "FabIntegrationSnackbar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport GlobalStyles from '@mui/material/GlobalStyles';\nimport Toolbar from '@mui/material/Toolbar';\nimport IconButton from '@mui/material/IconButton';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Fab from '@mui/material/Fab';\nimport AddIcon from '@mui/icons-material/Add';\nimport Snackbar from '@mui/material/Snackbar';\n\nexport default function FabIntegrationSnackbar() {\n  return (\n    <React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <CssBaseline />\n      <GlobalStyles\n        styles={(theme) => ({\n          body: { backgroundColor: theme.palette.background.paper },\n        })}\n      />\n      <div>\n        <AppBar position=\"static\" color=\"primary\">\n          <Toolbar>\n            <IconButton\n              edge=\"start\"\n              sx={{ mr: 2 }}\n              color=\"inherit\"\n              aria-label=\"menu\"\n            >\n              <MenuIcon />\n            </IconButton>\n            <Typography\n              variant=\"h6\"\n              component=\"div\"\n              sx={{\n                color: 'inherit',\n              }}\n            >\n              App bar\n            </Typography>\n          </Toolbar>\n        </AppBar>\n        <Fab\n          color=\"secondary\"\n          sx={(theme) => ({\n            position: 'absolute',\n            bottom: theme.spacing(2),\n            right: theme.spacing(2),\n          })}\n        >\n          <AddIcon />\n        </Fab>\n        <Snackbar\n          open\n          autoHideDuration={6000}\n          message=\"Archived\"\n          action={\n            <Button color=\"inherit\" size=\"small\">\n              Undo\n            </Button>\n          }\n          sx={{ bottom: { xs: 90, sm: 0 } }}\n        />\n      </div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </React.Fragment>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 69,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport GlobalStyles from '@mui/material/GlobalStyles';\nimport Toolbar from '@mui/material/Toolbar';\nimport IconButton from '@mui/material/IconButton';\nimport MenuIcon from '@mui/icons-material/Menu';\nimport Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport Fab from '@mui/material/Fab';\nimport AddIcon from '@mui/icons-material/Add';\nimport Snackbar from '@mui/material/Snackbar';\n\nexport default function FabIntegrationSnackbar() {\n  return (\n    <React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <CssBaseline />\n      <GlobalStyles\n        styles={(theme) => ({\n          body: { backgroundColor: theme.palette.background.paper },\n        })}\n      />\n      <div>\n        <AppBar position=\"static\" color=\"primary\">\n          <Toolbar>\n            <IconButton\n              edge=\"start\"\n              sx={{ mr: 2 }}\n              color=\"inherit\"\n              aria-label=\"menu\"\n            >\n              <MenuIcon />\n            </IconButton>\n            <Typography\n              variant=\"h6\"\n              component=\"div\"\n              sx={{\n                color: 'inherit',\n              }}\n            >\n              App bar\n            </Typography>\n          </Toolbar>\n        </AppBar>\n        <Fab\n          color=\"secondary\"\n          sx={(theme) => ({\n            position: 'absolute',\n            bottom: theme.spacing(2),\n            right: theme.spacing(2),\n          })}\n        >\n          <AddIcon />\n        </Fab>\n        <Snackbar\n          open\n          autoHideDuration={6000}\n          message=\"Archived\"\n          action={\n            <Button color=\"inherit\" size=\"small\">\n              Undo\n            </Button>\n          }\n          sx={{ bottom: { xs: 90, sm: 0 } }}\n        />\n      </div>\n"
      ],
      [
        "span",
        "frame",
        "    </React.Fragment>\n  );\n}\n"
      ]
    ],
    "totalLines": 69,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/AppBar",
      "@mui/material/CssBaseline",
      "@mui/material/GlobalStyles",
      "@mui/material/Toolbar",
      "@mui/material/IconButton",
      "@mui/icons-material/Menu",
      "@mui/material/Typography",
      "@mui/material/Button",
      "@mui/material/Fab",
      "@mui/icons-material/Add",
      "@mui/material/Snackbar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
